"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const userInfo = {
    userId: '',
    authToken: '',
};
exports.default = userInfo;
